import type { IUser } from './user';
import ky from 'ky';

import { api } from '@/utils/api';
import { API_URL } from '@/utils/environment';

export const userApi = {
  // does not use the base `api` instance (which redirects on 401) — intended for the login page to check auth status without side effects
  tryGet: () => ky.get(`${API_URL}/api/v1/shared/user`, { credentials: 'include' }).json<IUser>(),
  get: () => api.get(`api/v1/shared/user`).json<IUser>(),
  updateLanguage: (language: string) => api.patch(`api/v1/shared/user/language`, { json: { language } }),
};
